<svg class="lg-chart-legend__item--line-chart-custom__icon" height="16" width="16">
    @switch (_symbol) {
        @case ("line") {
            <line
                x1="0"
                y1="8"
                x2="16"
                y2="8"
                [style.stroke]="color"
                [style.stroke-width]="_lineStrokeWidth"
            />
        }
        @case ("line-dashed") {
            <line
                x1="0"
                y1="8"
                x2="16"
                y2="8"
                stroke-dasharray="5"
                [style.stroke]="color"
                [style.stroke-width]="_lineStrokeWidth"
            />
        }
        @case ("square") {
            <rect
                width="16"
                height="16"
                [style.fill]="color"
                [style.fill-opacity]="opacity"
                [ngStyle]="{ 'stroke-width': _symbolBorderWidth }"
                [style.stroke]="color"
            />
        }
        @case ("circle") {
            <circle
                cx="8"
                cy="8"
                r="5"
                [style.fill]="color"
                [style.fill-opacity]="opacity"
                [ngStyle]="{ 'stroke-width': _symbolBorderWidth }"
                [style.stroke]="color"
            />
        }
        @case ("triangle") {
            <polygon
                points="8,3 2,13 14,13"
                [style.fill]="color"
                [style.fill-opacity]="opacity ?? 1"
                [ngStyle]="{ 'stroke-width': _symbolBorderWidth }"
                [style.stroke]="color"
            />
        }
        @case ("line-with-circle") {
            <ng-container>
                <line
                    x1="0"
                    y1="8"
                    x2="16"
                    y2="8"
                    [style.stroke]="color"
                    [style.stroke-width]="_lineStrokeWidth"
                />
                <circle cx="8" cy="8" r="4" [style.stroke]="color" stroke-width="2" fill="white" />
            </ng-container>
        }
    }
</svg>
